export default __webpack_public_path__ + "static/media/CH.59e52fda.ico";